import { render, staticRenderFns } from "./DecisionEditor.vue?vue&type=template&id=77baa3f4&scoped=true&"
import script from "./DecisionEditor.vue?vue&type=script&lang=js&"
export * from "./DecisionEditor.vue?vue&type=script&lang=js&"
import style0 from "./DecisionEditor.vue?vue&type=style&index=0&id=77baa3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77baa3f4",
  null
  
)

export default component.exports